// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"4039e73c","239":"2e7d3504","281":"ce4ec7a0","283":"f8cea192","455":"aaeff0b8","479":"bb18f9f8","488":"2f14f5ab","657":"0b543268","662":"1b0ce1f5","776":"8e5830d7","778":"7bc17b33","801":"a2176aed","827":"790bb00d","960":"28a409df","977":"979c2d72","985":"2b827dea"}[chunkId] + ".chunk.js";
};